export default __webpack_public_path__ + "static/media/Enabill-logo.b3bb2751.svg";